export type AnalyticsEventWithLabel = {
  action: AnalyticsActions;
  category: AnalyticsCategory;
  label: string;
};

export enum AnalyticsActions {
  ACTION = "bruker gjorde en handling",
}

export enum AnalyticsCategory {
  REGISTRERING = "registerering",
  PARTNERONBOARDING = "partneronboarding",
}

export type AnalyticsPageView = [
  "trackdynamic",
  {
    url: string;
    ref?: string;
    title: string;
  },
];

export type AnalyticsEvent = [
  "event",
  AnalyticsCategory,
  AnalyticsActions,
  string | undefined,
];

export type AnalyticsToggleTrackingAction = ["notrack"] | ["notrack", false];

export type AnalyticsAction =
  | AnalyticsPageView
  | AnalyticsEvent
  | AnalyticsToggleTrackingAction;
